import { render, staticRenderFns } from "./TestingOrganizationsThreeChoiceModal.vue?vue&type=template&id=68e8ccc3&"
import script from "./TestingOrganizationsThreeChoiceModal.vue?vue&type=script&lang=ts&"
export * from "./TestingOrganizationsThreeChoiceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports